/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
} from "@angular/core";
import { FloatingComponent } from "../floating/floating.component";
import { ShotScoreService } from "../shot-score.service";

import { TranslateService } from "@ngx-translate/core";
import _ from "lodash";
import { getAvgPartsReverseMap } from "../../../utils/evaluationMethod";
/**
 * todo
 */
@Component({
	selector: "aigia-posture-tab",
	templateUrl: "./posture-tab.component.html",
	styleUrls: [
		"../floating/floating.component.css",
		"./posture-tab.component.css",
	],
})
export class PostureTabComponent
	extends FloatingComponent
	implements OnInit, OnChanges
{
	@Input() public locked: boolean;
	@Input() public shots: any;
	@Input() public size: number[];
	@Input() public style: any;
	@Input() public modeviewadvice: boolean;
	@Input() public modeviewavg: boolean;

	public hasData: boolean = false;
	public title: string = "Tab";
	public calc: string = "individual";

	@Output() public progrssChange = new EventEmitter<boolean>();

	public dataSources: {
		name: string;
		id: string;
		table: any[][];
		description: { club: number };
	}[] = [];

	public progress = false;
	public breakpoint = 0;

	/**
	 *
	 * @param shotscore
	 */
	constructor(
		public shotscore: ShotScoreService,
		public translate: TranslateService
	) {
		super();
	}

	public avgShotPartsMap = getAvgPartsReverseMap();

	/**
	 * @returns none
	 */
	private pointToName(point: string, club: number): string {
		let partsMap: any = {
			前傾角度: "前傾ライン",
			首元の動き: "ネックポジション",
			背骨の傾き: "センターライン",
			重心の動き_正面: "センターポジション",
			右腰の動き: "ライトライン",
			左腰の動き: "レフトライン",
			右膝の角度: "右膝の角度",
			左膝の角度: "左膝の角度",
		};
		if (this.modeviewavg) {
			partsMap = this.avgShotPartsMap[club];
		}

		let result = partsMap[point] || "";
		// console.log("pointToName", point, result);

		return result;
	}

	/**
	 * @returns none
	 */
	private nameToPosition(point: string, club: number): number {
		let positionPartsMap = {
			前傾ライン: 1,
			ネックポジション: 6,
			センターライン: 3,
			センターポジション: 2,
			ライトライン: 4,
			レフトライン: 5,
			右膝の角度: 7,
			左膝の角度: 8,
		};

		let result = positionPartsMap[point] || 0;

		if (this.modeviewavg) {
			result =
				Object.values(this.avgShotPartsMap[club]).indexOf(point) + 1;
		}

		// console.log("nameToPosition", point, result);

		return result;
	}

	/**
	 * @returns none
	 */
	private header(keys: any): string[] {
		const result = [""];
		keys.forEach((key: string): void => {
			result.push(this.phaseToName(key));
		});
		return result;
	}

	/**
	 * @returns none
	 */
	public phaseToName(phase: string): string {
		let result: string = "";
		switch (phase) {
			case "address":
				result = "AD";
				break;
			case "backswing":
				result = "HB";
				break;
			case "top":
				result = "TP";
				break;
			case "halfdown":
				result = "HD";
				break;
			case "impact":
				result = "IM";
				break;
			case "follow":
				result = "HF";
				break;
			case "finish":
				result = "FN";
				break;
			default:
				break;
		}
		return result;
	}

	/**
	 * @returns none
	 */
	public Truncate(value: string, start: number, limit: number): string {
		return value.substring(start, limit);
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		if (changes) {
			Object.keys(changes).forEach((propName) => {
				switch (propName) {
					case "visible":
					case "shots":
						if (this.visible) {
							this.draw(this.shots);
						}
						// 		this.draw(changes.shots-mongo.currentValue);
						break;
					// case "fontsize":
					// 	if (changes.fontsize.currentValue) {
					// 		const size: string = changes.fontsize.currentValue;
					// 		this.style = {"font-size": size};
					// 	}
					// 	break;
					default:
				}
			});
		} else {
			// Todo: error code messege
		}
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.breakpoint = this.widthToColumns(document.body.clientWidth);
	}

	public total(shots: any): any[] {
		const tables: any[] = [];
		const total: any[] = [];
		shots.forEach((target_shot: any): void => {
			const sm: any = target_shot.sm;
			if (sm) {
				const table: any[][] = [];
				Object.keys(sm).forEach((point_key, index) => {
					const point: any = sm[point_key];
					const line: string[] = [];
					Object.keys(point).forEach((phase_key) => {
						const phase: any = point[phase_key];
						const metrics: string = phase.metrics;
						line.push(metrics);
					});
					table.push(line);
				});
				tables.push(table);
			}

			// totalするための初期構造(0畑)を作る
			for (
				let line_count = 0;
				line_count < tables[0].length;
				line_count++
			) {
				const line = [];
				for (
					let cell_count = 0;
					cell_count < tables[0][line_count].length;
					cell_count++
				) {
					line.push(0);
				}
				total.push(line);
			}
		});

		// 0畑に値を育てる
		for (let table_count = 0; table_count < tables.length; table_count++) {
			for (
				let line_count = 0;
				line_count < tables[table_count].length;
				line_count++
			) {
				for (
					let cell_count = 0;
					cell_count < tables[table_count][line_count].length;
					cell_count++
				) {
					total[line_count][cell_count] +=
						tables[table_count][line_count][cell_count];
				}
			}
		}

		return total;
	}

	/**
	 * @returns none
	 */
	public draw(shots: any): void {
		this.Progress(true);
		try {
			const total = this.total(shots);
			const dataSources: any[] = [];
			if (shots.length > 0) {
				this.hasData = true;
				let dataSource: any = null;
				shots.forEach((target_shot: any): void => {
					if (target_shot) {
						const sm: any = target_shot.sm;
						const platform: any = target_shot.platform;
						let calculatedData = target_shot.calculated_data;
						let club = _.get(platform, "description.club");

						if (sm) {
							dataSource = {
								name: "",
								id: "",
								description: { club: 0 },
							};
							const table: any[][] = [
								[],
								[],
								[],
								[],
								[],
								[],
								[],
								[],
							];

							if (calculatedData) {
								let { parts } = calculatedData;
								table[0] = [
									"",
									"AD",
									"HB",
									"TP",
									"HD",
									"IM",
									"HF",
									"FN",
								];
								parts.forEach((p, pIdx) => {
									let pData = {
										part: p.part,
										label: p.part,
										...p,
										address: {},
										backswing: {},
										top: {},
										halfdown: {},
										impact: {},
										follow: {},
										finish: {},
									};

									[
										"address",
										"backswing",
										"top",
										"halfdown",
										"impact",
										"follow",
										"finish",
									].forEach((f) => {
										let metrics = 0,
											avarage = 0,
											unit = "",
											mark = "";

										let partData = parts.find(
											(x) => x.part == p.part
										);
										metrics = _.round(
											_.get(
												partData,
												["user", f, "metrics0"],
												0
											)
										);

										avarage = metrics;
										unit = _.get(
											partData,
											["detail", f, "unit"],
											""
										);
										mark = _.get(
											partData,
											["detail", f, "mark_alpha"],
											""
										);
										unit = _.get(
											partData,
											["detail", f, "unit"],
											""
										);

										pData[f] = {
											user_round: {
												...partData.user[f],
												metrics: _.round(
													partData.user[f].metrics,
													0
												),
												metrics0: _.round(
													partData.user[f].metrics0,
													0
												),
											},
											user: partData.user[f],
											pro: _.get(
												partData,
												["pro", f],
												{}
											),
											metrics,
											avarage,
											unit,
											mark,
											info: p,
											phase: f,
											is_calculated_data: true,
											method: calculatedData.method,
										};
									});

									table[pIdx + 1] = [
										pData.label,
										...[
											"address",
											"backswing",
											"top",
											"halfdown",
											"impact",
											"follow",
											"finish",
										].map((f) => pData[f]),
									];
								});
							} else {
								Object.keys(sm).forEach((point_key, index) => {
									const point: any = sm[point_key];
									if (index === 0) {
										table[0] = this.header(
											Object.keys(point)
										);
									}
									const name: string = this.pointToName(
										point_key,
										club
									);
									if (name) {
										const line: any[] = [name];
										Object.keys(point).forEach(
											(phase_key, line_count) => {
												const phase: any =
													point[phase_key];
												const total_metrics: number =
													total[index][line_count];
												const metrics: number =
													Math.round(phase.metrics);
												const avarage: number =
													Math.round(
														total_metrics /
															shots.length
													);
												line.push({
													metrics,
													avarage,
													unit: phase.unit,
												});
											}
										);

										line[0] = this.translate.instant(
											line[0]
										);
										table[this.nameToPosition(name, club)] =
											line;
										// 		table.push(line);
									} else {
										// Todo: error code messege
									}
								});
							}

							dataSource.name = target_shot.name;
							dataSource.id = target_shot._id;
							dataSource.table = table;
							dataSource.description.club =
								platform.description.club;

							dataSources.push(dataSource);
						}
					} else {
						// Todo: error code messege
					}
				});
			} else {
				this.hasData = false;
			}

			this.dataSources = dataSources;

			console.log("dataSources", dataSources);
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * todo
	 */
	public tableWidth(index: any): any {
		// let width = 25 + '%';
		let width = 27 + "%";
		if (index !== 0) {
			width = 10.5 + "%";
		}
		return { width: width };
	}

	/**
	 * @returns none
	 */
	public headerTitle(): any {
		const width = (this.size[0] / 16) * 3;
		const fontsize = this.size[1] / 35;
		let lineheight = fontsize * 1.5;
		if (this.modeviewadvice) {
			lineheight = this.size[1] / 9;
		}
		return { width: width + "px;", "line-height": lineheight + "px" };
		// return {width: 100 + "%", "line-height": lineheight + "px"};
	}

	/**
	 * @returns none
	 */
	public headerCell(columns: number): any {
		const width = this.size[0] / 18;
		let fontsize = this.size[1] / 30;
		let lineheight = fontsize * 1.5;
		if (this.modeviewadvice) {
			lineheight = this.size[1] / 9;
		}
		if (this.breakpoint <= 2) {
			fontsize = this.size[1] / 40;
		}
		let background = "#000000;";
		if (columns % 2 === 0) {
			background = "#0d0d0d;";
		}
		// return {width: width + "px;", "line-height": lineheight + "px", "font-size": fontsize + "px", "font-weight": "700"};
		return {
			width: 100 + "%;",
			"line-height": lineheight + "px",
			"font-size": fontsize + "px",
			"font-weight": "700",
			"background-color": background,
		};
	}

	public isRedCell(cell) {
		if (
			cell.method == "0003_AIGIA_Method(Myself)" &&
			cell.mark &&
			cell.mark !== "A"
		)
			return true;
		if (
			cell.method.indexOf("AIGIA") !== 0 &&
			cell.mark &&
			cell.mark !== "A"
		)
			return true;

		return cell.mark == "other";
	}

	public rowTitle(dataSource: any, line: any[], rows: number): any {
		const width = (this.size[0] / 20) * 3;
		let fontsize = this.size[1] / 44;
		let lineheight = fontsize * 3.0;
		if (this.modeviewadvice) {
			lineheight = this.size[1] / 9;
		}
		if (this.breakpoint <= 2) {
			fontsize = this.size[1] / 76;
		}
		const result: any = {
			width: 100 + "%;",
			"line-height": lineheight + "px",
			color: "#FFFFFF;",
			"font-size": fontsize + "px",
			"background-color": "#212121;",
			"text-align": "left",
			"padding-left": "7px",
		};
		const club: number = dataSource.description.club;
		let isCalculatedData = _.get(line, [1, "is_calculated_data"]);
		if (
			!this.modeviewavg &&
			(isCalculatedData
				? [1, 2, 3, 4, 5, 6, 7].find((x) => this.isRedCell(line[x]))
				: this.shotscore.is_error(club, line, this.calc))
		) {
			result.color = "#ffffff;";
			result["background"] =
				"linear-gradient(to right, #8c2339, 70%, #212121);";
		}
		return result;
	}

	/**
	 * @returns none
	 */
	public rowCell(columns: number): any {
		const width = this.size[0] / 17;
		let fontsize = this.size[1] / 40;
		let lineheight = fontsize * 2.8;
		if (this.modeviewadvice) {
			lineheight = this.size[1] / 9;
		}
		if (this.breakpoint <= 2) {
			fontsize = this.size[1] / 76;
		}

		// const result: any = {width: width + "px;", "line-height": lineheight + "px", color: "#303030;", "font-size": fontsize + "px", "background-color": "#f0f8ff;"};
		const result: any = {
			whiteSpace: "nowrap",
			width: 100 + "%;",
			"line-height": lineheight + "px",
			color: "#FFFFFF;",
			"font-size": fontsize + "px",
			"background-color": "#212121;",
		};
		if (columns % 2 === 0) {
			result["background-color"] = "#2c2c2c;";
		}
		return result;
	}

	// todo: judgement by cells.
	/**
	 * @returns unit
	 */
	public cellStyle(dataSource: any, line: any[], columns: number): any {
		const result = this.rowCell(columns);
		const club: number = dataSource.description.club;
		let isCalculatedData = _.get(line, [1, "is_calculated_data"]);
		if (
			!this.modeviewavg &&
			(isCalculatedData
				? this.isRedCell(line[columns])
				: this.shotscore.is_error_cell(club, line, columns, this.calc))
		) {
			result["background-image"] =
				"radial-gradient(#8c2339 50%, #333333);";
			result["color"] = "#fdfdfd;";
		}
		return result;
	}

	/**
	 * @returns unit
	 */
	public unit(rows: number, line: any): string {
		if (this.modeviewavg) {
			return _.get(line, [1, "unit"]) || "";
		}
		const units = ["", "°", "cm", "°", "°", "°", "cm", "°", "°"];
		return units[rows];
	}

	/**
	 * @returns style
	 */
	public maxSize(): any {
		return { height: "fit-content", width: this.size[0] + "px" };
	}

	public calcChange(event: any): void {
		if (this.visible) {
			this.calc = event.value;
			this.draw(this.shots);
		}
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

	/**
	 * @returns name
	 */
	public shotName(index: number): string {
		return "Shot " + (index + 1);
	}

	/*
	 * width to grid columns
	 * override
	 * @returns columns
	 */
	public widthToColumns(width: number): number {
		let result: number;
		result = width / 320;
		return result;
	}

	/*
	 *  @returns none
	 */
	public onResize(event: any): void {
		this.breakpoint = this.widthToColumns(event.target.innerWidth);
	}
}
